import { gsap, Cubic } from "gsap";
export default class Tabs {
  constructor() {
    this.contents = document.querySelector('.products-storeitems');
    
    this.tabs = this.contents.querySelectorAll('._tab');
    this.lists = this.contents.querySelectorAll('.products-storeitems__list');

    this.setup()
  }

  setup () {
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].addEventListener('click', (event) => {
        let list = this.contents.querySelector(this.tabs[i].dataset.open)
        this.remove();
        this.tabs[i].classList.add("on");
        list.classList.remove("off");
        this.fadein(list);
      });
    }

    this.contents.querySelectorAll(".c-card").forEach((elm, index) => {
      gsap.set(elm, {opacity: 0});
    });

    //一つ目のタブを選択
    this.tabs[0].click();
  }

  remove() {
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].classList.remove("on");
    }
    for (let i = 0; i < this.lists.length; i++) {
      this.lists[i].classList.add("off");
    }
  }

  fadein(elm) {
    elm.querySelectorAll(".c-card").forEach((elm, index) => {
      gsap.fromTo(
        elm,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 1.5,
          delay: 0.06 * index,
          ease: Cubic.easeOut
        }
      );
    });
  }

}